import i18n from '@cdo/locale';

export const TEACHING_STYLES = [
  {
    name: i18n.teachingStyleInnovatorName(),
    emoji: '🚀',
    tagline: i18n.teachingStyleInnovatorTagline(),
    teachingSuperpowers: [
      i18n.teachingStyleInnovatorSuperpower1(),
      i18n.teachingStyleInnovatorSuperpower2(),
      i18n.teachingStyleInnovatorSuperpower3(),
    ],
    howAiHelps: [
      i18n.teachingStyleInnovatorAiHelp1(),
      i18n.teachingStyleInnovatorAiHelp2(),
      i18n.teachingStyleInnovatorAiHelp3(),
    ],
  },
  {
    name: i18n.teachingStyleCodeWhispererName(),
    emoji: '🔍',
    tagline: i18n.teachingStyleCodeWhispererTagline(),
    teachingSuperpowers: [
      i18n.teachingStyleCodeWhispererSuperpower1(),
      i18n.teachingStyleCodeWhispererSuperpower2(),
      i18n.teachingStyleCodeWhispererSuperpower3(),
    ],
    howAiHelps: [
      i18n.teachingStyleCodeWhispererAiHelp1(),
      i18n.teachingStyleCodeWhispererAiHelp2(),
      i18n.teachingStyleCodeWhispererAiHelp3(),
    ],
  },
  {
    name: i18n.teachingStyleBridgeBuilderName(),
    emoji: '🌉',
    tagline: i18n.teachingStyleBridgeBuilderTagline(),
    teachingSuperpowers: [
      i18n.teachingStyleBridgeBuilderSuperpower1(),
      i18n.teachingStyleBridgeBuilderSuperpower2(),
      i18n.teachingStyleBridgeBuilderSuperpower3(),
    ],
    howAiHelps: [
      i18n.teachingStyleBridgeBuilderAiHelp1(),
      i18n.teachingStyleBridgeBuilderAiHelp2(),
      i18n.teachingStyleBridgeBuilderAiHelp3(),
    ],
  },
  {
    name: i18n.teachingStyleStorytellerName(),
    emoji: '📚',
    tagline: i18n.teachingStyleStorytellerTagline(),
    teachingSuperpowers: [
      i18n.teachingStyleStorytellerSuperpower1(),
      i18n.teachingStyleStorytellerSuperpower2(),
      i18n.teachingStyleStorytellerSuperpower3(),
    ],
    howAiHelps: [
      i18n.teachingStyleStorytellerAiHelp1(),
      i18n.teachingStyleStorytellerAiHelp2(),
      i18n.teachingStyleStorytellerAiHelp3(),
    ],
  },
  {
    name: i18n.teachingStyleCommunityArchitectName(),
    emoji: '👥',
    tagline: i18n.teachingStyleCommunityArchitectTagline(),
    teachingSuperpowers: [
      i18n.teachingStyleCommunityArchitectSuperpower1(),
      i18n.teachingStyleCommunityArchitectSuperpower2(),
      i18n.teachingStyleCommunityArchitectSuperpower3(),
    ],
    howAiHelps: [
      i18n.teachingStyleCommunityArchitectAiHelp1(),
      i18n.teachingStyleCommunityArchitectAiHelp2(),
      i18n.teachingStyleCommunityArchitectAiHelp3(),
    ],
  },
  {
    name: i18n.teachingStyleLeadLearnerName(),
    emoji: '🌟',
    tagline: i18n.teachingStyleLeadLearnerTagline(),
    teachingSuperpowers: [
      i18n.teachingStyleLeadLearnerSuperpower1(),
      i18n.teachingStyleLeadLearnerSuperpower2(),
      i18n.teachingStyleLeadLearnerSuperpower3(),
    ],
    howAiHelps: [
      i18n.teachingStyleLeadLearnerAiHelp1(),
      i18n.teachingStyleLeadLearnerAiHelp2(),
      i18n.teachingStyleLeadLearnerAiHelp3(),
    ],
  },
];
